import { useState } from 'react';
import AdminLayout from './AdminLayout';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
import { FaFileUpload } from 'react-icons/fa';
import { MdPublish } from 'react-icons/md';
import CustomizedSnackbars from "../../Feedback";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { useFirebase } from 'react-redux-firebase';
import { noticeAction } from '../../../Firebase/actions/noticeAction';
import { useEffect } from 'react';
import moment from 'moment';
import M from 'materialize-css/dist/js/materialize.min';

const useStyles = makeStyles({
    field: {
        marginTop: 25,    
        borderBottom: 'none'
    },
    btn: {
        marginBottom: 25,
        marginTop: 30,
        textAlign: "center"
    }
});

const CreateNotice = ({ noticeAction, addNoticeSuccess, addNoticeError, admins, auth, resetSuccess }) => {
    const classes = useStyles();
    const [ topic, setTopic ] = useState('');
    const [ body, setBody ] = useState('');
    const [ file, setFile ] = useState('');
    const [ error, setError ] = useState(false);
    const [ error2, setError2 ] = useState(false);
    const [ error3, setError3 ] = useState(false);
    const [ audience, setAudience ] = useState('');

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();

    let output;
    if(auth.uid) {
        let admin;
        
        if (admins) {
            
            admin = admins.filter((item) => {
                return item.id === auth.uid
            });  
            
            output = admin[0];     //console.log(output, auth);
            
        }     
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if(topic === '' ) {
            setError(true);
            return ;
        } else {
            setError(false);
        }
        if(audience === '') {
            setError3('Please select an audience.');
            return;
        } else {
            setError3(false);
        }


        if(body === '' ) {
            setError2(true);
            return ;
        } else {
            setError2(false);

            if(file !== '') {
                // storagee references
                const storageRef = firebase.storage().ref(`notices/${file.name}`);
                document.getElementById('Btn').classList.add('is-loading');

                storageRef.put(file).on('state change', (snap) => {
                    document.getElementById('Btn').classList.add('is-loading');
                }, (err) => {
                    setFeedbackText('Error occured. Please Try again.');
                    setSeverity('error');
                    setOpenFeedback(true);
                }, async () => {
                    document.getElementById('Btn').classList.remove('is-loading');

                    const url = await storageRef.getDownloadURL();
                    //console.log(url);
                    let data = {
                        topic,
                        body,
                        url,
                        audience,
                        filename: file.name,
                        date: moment().format('LL'),
                        uploadedBy: output.title + output.surname,
                        postDate: new Date()
                    }
                    noticeAction(data, audience);
                
                }); 

            } else {
                document.getElementById('Btn').classList.add('is-loading');
                let data = {
                    topic,
                    body,
                    audience,
                    date: moment().format('LL'),
                    uploadedBy: output.title + output.surname,
                    postDate: new Date()
                }
                noticeAction(data, audience);
            }       
        }
    }

    useEffect(() => {

        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });
    
        
        if(addNoticeSuccess) {
            document.getElementById('Btn').classList.remove('is-loading');
            //reset form 
            setFile('');
            setBody('');
            setTopic('');

            //on success
            setFeedbackText('Notice successfully posted.');
            setSeverity('success');
            setOpenFeedback(true);

            resetSuccess();
            
        }
        if(addNoticeError) {
            document.getElementById('Btn').classList.remove('is-loading');
            //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);

        }    
    }, [addNoticeError, addNoticeSuccess, topic, resetSuccess]);

    

    return ( 
        <AdminLayout>
            <div className="pt-5">
                <div className="container row">
                    <div className="col s10 m6 l4">
                        <div className="input-field">
                            <select onChange={(e) => setAudience(e.target.value)} value={audience} >
                                <option value="" disabled>Select</option>
                                <option value="Public">Public</option>
                                <option value="Teaching Staff">Teaching Staff</option>
                                <option value="All Students">All Students</option>
                                <optgroup label="Select by Division">
                                   <option value="Applied Arts">Applied Arts </option>
                                   <option value="Applied Science">Applied Science</option>
                                   <option value="Civil and Construction">Civil &amp; Construction</option>
                                   <option value="Engineering">Engineering</option>
                                   <option value="Commerce">Commerce</option>
                                   <option value="Education and Enterprise Dev.">Education &amp; Enterprise Dev.</option>
                                </optgroup>
                                <optgroup label="Select by Programme"></optgroup>
                                <optgroup label="Applied Art">
                                    <option value="Music">Music</option>
                                    <option value="Cosmetology">Cosmetology</option>
                                    <option value="Fashion Design">Fashion Design</option>
                                    <option value="Art and Design">Art and Design </option>
                                    <option value="Clothing">Clothing</option>
                                </optgroup>
                                <optgroup label="Applied Science">
                                    <option value="Science Technology">Science Technology</option>
                                    <option value="Horticulture">Horticulture</option>
                                </optgroup>
                                <optgroup label="Hospitality">
                                    <option value="Food and Beverage Service">Food & Beverage Service</option>
                                    <option value="Bakery Studies">Bakery Studies</option>
                                    <option value="Tourism and Hospitality Management">Tourism & Hospitality Management</option>
                                    <option value="Professional Cookery">Professional Cookery</option>        
                                </optgroup>
                                <optgroup label="Construction and Wood Technology">
                                    <option value="Brick and Block Laying">Brick and Block Laying</option>
                                    <option value="Painting and Decorating">Painting and Decorating</option>
                                    <option value="Plumbing and Drain Laying">Plumbing and Drain Laying</option>
                                    <option value="Carpentry and Joinery">Carpentry and Joinery</option>
                                    <option value="Wood Machines and Manufacturing">Wood Machines and Manufacturing</option>
                                    <option value="Construction Technology">Construction Technology</option>
                                </optgroup>
                                <optgroup label="Civil Engineering">
                                    <option value="Civil Engineering">Civil Engineering</option>
                                    <option value="Quantity Surveying Engineering">Quantity Surveying Engineering</option>
                                    <option value="Water Resources and Irrigation Engineering">Water Resources & Irrigation Engineering</option>
                                </optgroup>
                                <optgroup label="Automotive">
                                    <option value="Motor Vehicle Body Repairs + Refinishing">Motor Vehicle Body Repairs + Refinishing</option>
                                    <option value="Motor Vehicle Mechanics">Motor Vehicle Mechanics</option>
                                    <option value="Automobile Electrics and Electronics">Automobile Electrics & Electronics</option>
                                </optgroup>
                                <optgroup label="Electrical">
                                    <option value="Electrical Power">Electrical Power</option>
                                    <option value="Computer Systems">Computer Systems</option>
                                    <option value="Communication Systems">Communication Systems</option>
                                </optgroup>
                                <optgroup label="Mechanical">
                                    <option value="Diesel Plant Fitting">Diesel Plant Fitting</option>
                                    <option value="Fabrication Engineering">Fabrication Engineering</option>
                                    <option value="Machine Shop Engineering">Machine Shop Engineering</option>
                                    <option value="Refrigeration and Air Conditioning">Refrigeration & Air Conditioning</option>
                                    <option value="Production Engineering">Production Engineering</option>
                                    <option value="Mechanical Engineering">Mechanical Engineering</option>
                                </optgroup>
                                <optgroup label="Business Studies">
                                    <option value="Accountancy">Accountancy</option>
                                    <option value="Banking and Finance">Banking and Finance</option>
                                </optgroup>
                                <optgroup label="Management Studies">
                                    <option value="Transport and Logistics Management">Transport & Logistics Management</option>
                                    <option value="Marketing Management">Marketing Management</option>
                                    <option value="Human Resources">Human Resources</option>
                                    <option value="Purchasing and Supply">Purchasing and Supply</option>
                                </optgroup>
                                <optgroup label="Office Management">
                                    <option value="Secretarial">Secretarial</option>
                                    <option value="Office Management">Office Management</option>
                                </optgroup>
                                <optgroup label="IM Systems">
                                    <option value="Information Technology">Information Technology</option>
                                    <option value="Library and Information Science">Library and Information Science</option>
                                    <option value="Records Management and Info Science">Records Management and Info Science</option>
                                </optgroup>
                                <optgroup label="Education">
                                    <option value="Further Education Trainers Certificate">Further Education Trainers Certificate</option>
                                    <option value="Further Education Trainers Diploma">Further Education Trainers Diploma</option>
                                </optgroup>
                            </select>
                            <label>Select Audience: </label>
                        </div>
                    </div>
                </div>
                <div className="box container px-5">
                    <h6 className="subtitle has-text-weight-semibold mt-2 mb-2">Add a Notice.</h6>
                    <div className="divider"></div>
                    <form noValidate autoComplete="off" className="bb-none mt-4" onSubmit={handleSubmit}>
                        <TextField 
                            type="text"
                            label="Heading / Topic"
                            variant="outlined"
                            color="secondary"
                            className={classes.field}
                            fullWidth
                            error={error}
                            onChange={(e) => setTopic(e.target.value)} value={topic}
                        />
                        <TextField 
                            type="text"
                            label="Notice body"
                            variant="outlined"
                            color="secondary"
                            className={classes.field}
                            multiline
                            rows={7}
                            fullWidth
                            error={error2}
                            onChange={(e) => setBody(e.target.value)} value={body}
                        />

                        <div className="file-field input-field mt-5">
                            <div className="button is-small is-info">
                                <span className="icon">
                                    <FaFileUpload className="mr1" size="1.1rem" />
                                </span>
                                <span>Attach a file</span>
                                <input type="file" onChange={(e) => setFile(e.target.files[0])} />
                            </div>
                            <div className="file-path-wrapper">
                                <input className="file-path validate" type="text" placeholder="Select a file, if the notice has one." />
                            </div>
                        </div>
                        {
                            error3 && <p className="red-text text-darken-3 is-size-6">{error3}</p>
                        }
                        <div className="control center mt-5">
                            <button className="button is-success" id="Btn">
                                <span className="icon">
                                    <MdPublish color="white"/>
                                </span>
                                <span className="white-text">Publish Notice</span>
                            </button>
                        </div>
                    </form>        
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </AdminLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addNoticeSuccess: state.notice.addNoticeSuccess,
        addNoticeError: state.notice.addNoticeError,
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth,
    }
    
}
 
const mapDispatchToProps = (dispatch) => {
    
    return {
        noticeAction: (notice) => dispatch(noticeAction(notice)),
        resetSuccess: () => dispatch({ type: "ADD_NOTICE", success: false })
    };
};


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(CreateNotice);
